import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModelsUser} from "../../../app/api/model/models";
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {Ripple} from 'primeng/ripple';

@Component({
  selector: 'app-hr-employee-form',
  template: `
    <p-dialog [(visible)]="visible" [style]="{width: '450px'}" header="Employee Details" [modal]="true"
              styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="field">
          <label for="first_name">First Name</label>
          <input type="text" pInputText id="first_name" [(ngModel)]="employee.first_name" required autofocus/>
        </div>
        <div class="field">
          <label for="last_name">Last Name</label>
          <input type="text" pInputText id="last_name" [(ngModel)]="employee.last_name" required/>
        </div>
        <div class="field">
          <label for="phone">Phone</label>
          <input type="text" pInputText id="phone" [(ngModel)]="employee.phone" required/>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveEmployee()"></button>
      </ng-template>
    </p-dialog>
  `,
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    Ripple
  ]
})
export class HrEmployeesForm {
  @Input() visible = false;
  @Input() employee: ModelsUser = {} as ModelsUser;
  @Output() onSave = new EventEmitter<ModelsUser>();
  @Output() onCancel = new EventEmitter<void>();

  hideDialog() {
    this.onCancel.emit();
  }

  saveEmployee() {
    this.onSave.emit(this.employee);
  }
}
